import { request } from '@/utils/request';

export const fetchPosts = async (params = {}) => {
  const response = await request.get('/post/', { params });
  return response.data;
};

export const fetchMyPosts = async (params = {}) => {
  const response = await request.get('/post/my/', { params });
  return response.data;
};

export const fetchPostDetail = async postId => {
  const response = await request.get(`/post/${postId}/`);
  return response.data;
};

export const fetchPostComments = async (postId, params = {}) => {
  const response = await request.get(`/post/${postId}/comments/`, { params });
  return response.data;
};

export const fetchPostComment = async (postId, commentId) => (await request.get(`/post/${postId}/comments/${commentId}/`)).data;
export const fetchCommentContext = async (postId, commentId) => (await request.get(`/post/${postId}/comments/${commentId}/context/`)).data;
export const fetchMyApplications = async (params = {}) => (await request.get('/post/my-applications/', { params })).data;
export const fetchMyApplication = async id => (await request.get(`/post/my-applications/${id}/`)).data;
export const fetchApplicationSummary = async () => (await request.get('/post/my-applications/summary/')).data;
export const withdrawApplication = async id => (await request.post(`/post/my-applications/${id}/withdraw/`, {})).data;
export const reapplyApplication = async id => (await request.post(`/post/my-applications/${id}/reapply/`, {})).data;
export const fetchMyReviews = async (params = {}) => (await request.get('/post/my-reviews/', { params })).data;
export const fetchReviewSummary = async () => (await request.get('/post/my-reviews/summary/')).data;
export const fetchMyRecommendationFeedback = async (params = {}) => (await request.get('/post/my-recommendation-feedback/', { params })).data;
export const deleteRecommendationFeedback = async id => request.delete(`/post/my-recommendation-feedback/${id}/`);
export const fetchCompletionSummary = async id => (await request.get(`/post/${id}/completion-summary/`)).data;

export const togglePostLike = async postId => {
  const response = await request.post(`/post/${postId}/like/`);
  return response.data;
};

export const createPostComment = async (postId, content, options = {}) => {
  const response = await request.post(`/post/${postId}/comments/`, { content, ...options });
  return response.data;
};

export const updatePost = async (id, data) => (await request.patch(`/post/${id}/`, data)).data;
export const deletePost = async id => request.delete(`/post/${id}/`);
export const closePost = async id => (await request.post(`/post/${id}/close/`)).data;
export const fetchPostConversation = async id => (await request.get(`/post/${id}/conversation/`)).data;
export const fetchApplications = async (id, params = {}) => (await request.get(`/post/${id}/recruitment/applications/`, { params })).data;
export const reviewApplication = async (id, applicationId, approved) => (await request.patch(`/post/${id}/recruitment/applications/${applicationId}/`, { approved })).data;
export const reviewApplications = async (id, applicationIds, approved) => (await request.patch(`/post/${id}/recruitment/applications/batch/`, { application_ids: applicationIds, approved })).data;

export const fetchRecommendedPosts = async (params = {}) => (await request.get('/post/recommendations/', { params })).data;
export const fetchNearbyPosts = async (params = {}) => (await request.get('/post/nearby/', { params })).data;
export const sendRecommendationFeedback = async (id, action) => request.post(`/post/${id}/recommendation-feedback/`, { action });
export const completePost = async (id, dissolveGroup = false) => (await request.post(`/post/${id}/complete/`, { dissolve_group: dissolveGroup })).data;
export const confirmPostCompletion = async id => (await request.post(`/post/${id}/confirm-completion/`)).data;
export const fetchPostReviews = async (id, params = {}) => (await request.get(`/post/${id}/reviews/`, { params })).data;
export const createPostReview = async (id, data) => (await request.post(`/post/${id}/reviews/`, data)).data;
export const fetchPostImageQuota = async () => (await request.get('/post/image-quota/')).data;
export const deletePostImage = async (id, imageId) => request.delete(`/post/${id}/images/${imageId}/`);

export const fetchPostTags = async (params = {}) => {
  const response = await request.get('/user/tags/', { params });
  return response.data;
};

export const favoritePost = async id => (await request.post(`/post/${id}/favorite/`, {})).data;
export const unfavoritePost = async id => request.delete(`/post/${id}/favorite/`);
export const fetchMyFavorites = async (params = {}) => (await request.get('/post/my-favorites/', { params })).data;
export const reopenPost = async (id, data) => (await request.post(`/post/${id}/reopen/`, data)).data;
export const extendPost = async (id, data) => (await request.post(`/post/${id}/extend/`, data)).data;
export const pinPost = async (id, isPinned) => (await request.patch(`/post/${id}/pin/`, { is_pinned: isPinned })).data;
export const fetchPostHeatmap = async (params = {}) => (await request.get('/post/heatmap/', { params })).data;
export const fetchRecommendationPreferences = async () => (await request.get('/post/recommendation-preferences/')).data;
export const updateRecommendationPreferences = async data => (await request.patch('/post/recommendation-preferences/', data)).data;
export const createRecommendationRun = async data => (await request.post('/post/recommendation-runs/', data)).data;
export const fetchRecommendationRuns = async (params = {}) => (await request.get('/post/recommendation-runs/', { params })).data;
export const fetchRecommendationRun = async id => (await request.get(`/post/recommendation-runs/${id}/`)).data;
export const sendRecommendationEvents = async events => (await request.post('/post/recommendation-events/', { events })).data;
export const fetchMatchHistory = async (params = {}) => (await request.get('/post/match-history/', { params })).data;

export const createPost = async postData => {
  const response = await request.post('/post/', postData);
  return response.data;
};

// 保留原有导出，帖子、聊天、标签等页面共用统一的请求错误提示。
export { getRequestErrorMessage as getPostErrorMessage } from '@/utils/requestError';
